import React from 'react'
import {Menu, Button} from 'semantic-ui-react'
import {
  useHistory
} from "react-router-dom";
import translations from '../../translations'

const t = translations

const MenuComponent = ({navigation}) => {
    const history = useHistory();

    return(<Menu size='large' color='blue'>
    <Menu.Item
      content={t.menu.title}
    />
    <Menu.Item position='right'>
        <Button primary onClick={()=>{
          localStorage.removeItem('ahpAccessToken')
          localStorage.removeItem('ahpRefreshToken')
          localStorage.removeItem('ahpUser')
          localStorage.removeItem('ahpUserRole')
          history.push('/')
        }}>{t.menu.logout}</Button>
    </Menu.Item>

  </Menu>)
}

export default MenuComponent